<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="storeTableArea"
                    label="桌位区域"
                >
                    <el-input
                        v-model="queryFormModel.storeTableArea"
                        placeholder="请输入桌位区域"
                    />
                </el-form-item>
                <el-form-item
                    prop="storeTableSn"
                    label="桌位号"
                >
                    <el-input
                        v-model="queryFormModel.storeTableSn"
                        placeholder="请输入桌位号"
                    />
                </el-form-item>
                <el-form-item
                    prop="storeTableType"
                    label="桌位类型"
                >
                    <dictionaries-picker
                        type="storeTableType"
                        v-model="queryFormModel.storeTableType"
                    />
                </el-form-item>
                <el-form-item
                    prop="isAvailable"
                    label="是否可用"
                >
                    <el-select
                        v-model="queryFormModel.isAvailable"
                        placeholder="请选择"
                    >
                        <el-option
                            key="1"
                            label="是"
                            value="1"
                        />
                        <el-option
                            key="2"
                            label="否"
                            value="0"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="onAdd"
                    >
                        新增
                    </el-button>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="storeTableArea"
                    label="桌位区域"
                    min-width="100"
                />
                <el-table-column
                    prop="storeTableSn"
                    label="桌位号"
                    min-width="100"
                />
                <el-table-column
                    prop="storeTableTypeName"
                    label="桌位类型"
                    min-width="100"
                />
                <el-table-column
                    label="是否可用"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isAvailable ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="160"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onShowShareInfo(scope.row)"
                        >
                            二维码
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="storeTableArea"
                    label="桌位区域"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.storeTableArea"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="storeTableSn"
                    label="桌位号"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.storeTableSn"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="storeTableType"
                    label="桌位类型"
                    label-width="6em"
                >
                    <dictionaries-picker
                        type="storeTableType"
                        v-model="addDialog.formModel.storeTableType"
                    />
                </el-form-item>
                <el-form-item
                    prop="isAvailable"
                    label="是否可用"
                    label-width="6em"
                >
                    <el-switch
                        v-model="addDialog.formModel.isAvailable"
                    />
                </el-form-item>
                <el-form-item
                    prop="remarks"
                    label="备注"
                    label-width="6em"
                >
                    <el-input
                        type="textarea"
                        v-model="addDialog.formModel.remarks"
                        auto-complete="off"
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="二维码"
            center
            width="600px"
            :visible.sync="shareInfoDialog.isVisible"
            @closed="onShareInfoDialogCancel"
        >
            <el-form
                ref="shareInfoForm"
                size="small"
                :model="shareInfoDialog.formModel"
                :rules="shareInfoDialog.formRules"
            >
                <el-form-item
                    label="小程序码"
                    label-width="9em"
                >
                    <img
                        width="200"
                        :src="shareInfoDialog.formModel.dineMinAppCodeImage"
                        alt=""
                    >
                    <div class="label">堂食点餐小程序码（右键另存为保存图片）</div>
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    size="small"
                    @click="onShareInfoDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'Variable',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                storeId: '',
                storeTableArea: '',
                storeTableSn: '',
                storeTableType: '',
                isAvailable: '',
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    storeId: '',
                    storeTableArea: '',
                    storeTableSn: '',
                    storeTableType: '',
                    isAvailable: true,
                    remarks: '',
                },
                // 表单校验规则
                formRules: {
                    storeTableSn: {
                        required: true,
                        message: '请输入桌位号',
                        trigger: 'blur',
                    },
                    storeTableType: {
                        required: true,
                        message: '请选择桌位类型',
                    },
                    isAvailable: {
                        required: true,
                        message: '请选择是否可用',
                    },
                },
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
            shareInfoDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    dineMinAppCodeImage: '',
                },
                // 表单校验规则
                formRules: {},
            },
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Sp.ShopStoreTable.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onAdd() {
            this.addDialog.isVisible = true;
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.$api.Sp.ShopStoreTable.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res);
            });
            this.addDialog.isVisible = true;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Sp.ShopStoreTable.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Sp.ShopStoreTable.save({
                    ...this.addDialog.formModel,
                    storeId: this.queryFormModel.storeId,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
        onShowShareInfo(row) {
            const { formModel } = this.shareInfoDialog;
            this.shareInfoDialog.formModel.id = row.id;
            this.$api.Sp.ShopStoreTable.getShareInfo({ id: this.shareInfoDialog.formModel.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res);
                this.shareInfoDialog.isVisible = true;
            });
        },
        onShareInfoDialogCancel() {
            const { shareInfoForm } = this.$refs;
            shareInfoForm.resetFields();
            const { formModel } = this.shareInfoDialog;
            formModel.id = '';
            this.shareInfoDialog.isVisible = false;
        },
    },
    created() {
        this.queryFormModel.storeId = this.$route.params.id;
    },
};
</script>

<style lang="scss">
</style>
